import { images } from '../../../Constants/ImageUrls';
import { HeadingContainer, TagListHeading } from './styled';

export default function TagListHeader() {
  return (
    <HeadingContainer>
      <TagListHeading>
        <h1>Explore Topics</h1>
        <p>
          Whether you&apos;re trying to get pregnant, are already expecting or
          are the parent of a baby or a toddler, you want as much information as
          you can get your hands on. Mylo can help you at every step of your
          parenting journey. Here are some of the most popular pregnancy and
          parenting topics
        </p>
        <img src={images.toolBannerWave} alt="" />
      </TagListHeading>
    </HeadingContainer>
  );
}
